import { EyeOutlined, FileOutlined } from '@ant-design/icons';
import helper from '../../utils/helper';

export default function ApproveDocUrlThumbs({ urls }: { urls: string[] | undefined }) {
    if (!Array.isArray(urls)) return null;
    return (
        <span className="approveDocs-docThumbs">
            {urls.map((url, i) => {
                if (url === '') return null;
                if (helper.isPdfUrl(url)) {
                    const pdfName = helper.fileNameFromUrl(url);
                    return (
                        <a
                            key={`pdf-${i}`}
                            className="approveDocs-pictureCardThumb approveDocs-pictureCardThumb--pdf"
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={`Open PDF in new tab: ${pdfName}`}
                            title={pdfName}
                        >
                            <span className="approveDocs-pictureCardThumb-inner">
                                <span className="approveDocs-pictureCardThumb-pdfBody">
                                    <FileOutlined className="approveDocs-pictureCardThumb-fileIcon" />
                                    <span className="approveDocs-pictureCardThumb-fileName">{pdfName}</span>
                                </span>
                                <span className="approveDocs-pictureCardThumb-mask" aria-hidden>
                                    <span className="approveDocs-pictureCardThumb-maskInfo">
                                        <EyeOutlined />
                                        <span>Preview</span>
                                    </span>
                                </span>
                            </span>
                        </a>
                    );
                }
                return (
                    <a
                        key={`img-${i}`}
                        className="approveDocs-pictureCardThumb approveDocs-pictureCardThumb--image"
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Open image in new tab"
                    >
                        <span className="approveDocs-pictureCardThumb-inner">
                            <img src={url} alt="" />
                            <span className="approveDocs-pictureCardThumb-mask" aria-hidden>
                                <span className="approveDocs-pictureCardThumb-maskInfo">
                                    <EyeOutlined />
                                    <span>Preview</span>
                                </span>
                            </span>
                        </span>
                    </a>
                );
            })}
        </span>
    );
}
